/* tslint:disable */
import { ViewFamily } from './view-family';
import { ViewTemperature } from './view-temperature';

/**
 */
export class ViewComponent {
    COMP_RELEASE?: number;
    productFamily?: ViewFamily[];
    subFamily?: ViewFamily[];
    SUB_TYPE?: number;
    productNature?: ViewFamily[];
    NATURE_TYPE?: number;
    Conductivity?: ViewFamily[];
    CONDUCT_TYPE?: number;
    FatType?: ViewFamily[];
    Temperatures?: ViewTemperature[];
    FATTYPE?: number;
    COMP_NAME?: string;
    COMP_NAME_NEW?: string;
    AIR?: number;
    BLS_CODE?: string;
    CLASS_TYPE?: number;
    COMP_COMMENT?: string;
    COMP_DATE?: string;
    COMP_GEN_STATUS?: number;
    COMP_IMP_ID_STUDY?: number;
    COMP_NATURE?: number;
    PRODUCT_TYPE?: number;
    COMP_VERSION?: number;
    COMP_VERSION_NEW?: number;
    COND_DENS_MODE?: number;
    DENSITY?: number;
    FAT_TYPE?: number;
    FREEZE_TEMP?: number;
    GLUCID?: number;
    ID_COMP?: number;
    ID_USER?: number;
    LIPID?: number;
    NON_FROZEN_WATER?: number;
    OPEN_BY_OWNER?: number;
    PROTID?: number;
    SALT?: number;
    SPECIFIC_HEAT?: number;
    SUB_FAMILY?: number;
    WATER?: number;
    release?: number;
    TYPE_COMP?: number;
    check?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-component.ts